export const userRoles = {
  adminUserRoles: ["Admin"] as const,
  clientUserRoles: ["Manager", "Auditor"] as const,
  agencyUserRoles: ["Supervisor", "Field Agent", "Call Center Agent", "Auditor"] as const,
  supervisorAllowedUserRoles: ["Field Agent", "Call Center Agent", "Auditor"] as const,
};